import { errorAction } from '@shared/actions';
import { GPS_PERMISSION_NOT_ALLOWED } from '@location/actionTypes';

const type = GPS_PERMISSION_NOT_ALLOWED;

const onGPSError = errorMessage =>
  errorAction({
    error: errorMessage,
    errorMessage,
    type,
  });

export default onGPSError;
